// 4.13 Mobile premium v2 (w1:pB): on phones the Compra Bot steps aside while the page scrolls and comes back when it stops,
// so it never rests on a price mid-scroll. Without JS the button simply stays where it is.
(() => {
  'use strict';
  if (!matchMedia('(max-width: 760px)').matches) return;
  const body = document.body;
  let timer;
  addEventListener('scroll', () => {
    body.classList.add('mb-moving');
    clearTimeout(timer);
    timer = setTimeout(() => body.classList.remove('mb-moving'), 450);
  }, { passive: true });
})();
